import React from 'react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import type { MenubarMenuModel } from '../types/menubar-menu-model'
import { DesktopEditMenu } from './desktop-edit-menu'
import { DesktopFileMenu } from './desktop-file-menu'
import { DesktopHelpMenu } from './desktop-help-menu'
import { DesktopObjectMenu } from './desktop-object-menu'
import { DesktopViewMenu } from './desktop-view-menu'
import { MenubarTriggerButton } from './menubar-trigger-button'

type DesktopMenuProps = {
  open: boolean
  onOpenChange: (isOpen: boolean) => void
  model: MenubarMenuModel
}

/** Desktop: DropdownMenu with Submenus */
export const DesktopMenu: React.FC<DesktopMenuProps> = ({ open, onOpenChange, model }) => {
  return (
    <DropdownMenu open={open} onOpenChange={onOpenChange}>
      <DropdownMenuTrigger asChild>
        <MenubarTriggerButton />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="w-[var(--menubar-menu-width)] max-w-[90vw]"
        align="start"
        sideOffset={8}
        data-text-edit-keepalive=""
      >
        <DesktopFileMenu
          onClose={model.onClose}
          openPreferencesDialog={model.openPreferencesDialog}
        />
        <DesktopEditMenu commands={model.editCommands} closeMenu={model.closeMenu} />
        <DesktopObjectMenu commands={model.objectCommands} closeMenu={model.closeMenu} />
        <DesktopViewMenu
          gridMode={model.gridMode}
          viewToggles={model.viewToggles}
          openGuidesDialog={model.openGuidesDialog}
        />
        <DesktopHelpMenu />
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
